<mat-toolbar class="titulopartes">Dados do Beneficiário</mat-toolbar>
<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <div fxFlex="8%" style="text-align: end">
        <button name="fotoPerfil" ng mat-raised-button class="foto" [style.background-image]="getBackground()" >
            <mat-icon class="nao-foto"></mat-icon>
        </button>
    </div>
        
    <mat-form-field fxFlex="10%" fxFlexOffset="20px" >
        <input matInput name="matricula" placeholder="Matricula" [(ngModel)]="aluno.matriculaAluno" disabled>
    </mat-form-field>

    <mat-form-field fxFlex="20%" fxFlexOffset="20px" >
        <input matInput name="nome" placeholder="Nome do aluno" [(ngModel)]="aluno.pessoaFisica.nome" disabled>
    </mat-form-field>

    <mat-form-field fxFlex="10%" fxFlexOffset="20px" >
        <input matInput name="identidade" placeholder="Identidade (CI)" [(ngModel)]="aluno.pessoaFisica.identidade" disabled>
    </mat-form-field>

    <mat-form-field fxFlex="10%" fxFlexOffset="20px" >
        <input matInput name="orgao" placeholder="Órgão (CI)" [(ngModel)]="aluno.pessoaFisica.orgaoCi" disabled>
    </mat-form-field>

    <mat-form-field fxFlex="10%" fxFlexOffset="20px" >
        <input matInput name="uf" placeholder="UF (CI)" [(ngModel)]="aluno.pessoaFisica.ufCi" disabled>
    </mat-form-field>

</div>


